import { http } from '@/services';

export default {
  getThemeList: async function() {
    try {
      return await http.get('tema/');
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  getThemeByProduct: async function(productId){
    try{
      return await http.get(`tema/residencia/${productId}`);
    }catch(e){
      return e.response.data;
    }
  },
  createTheme: async function(theme) {
    try {
      return await http.post('tema/', theme);
    } catch (e) {
      return e.response.data;
    }
  },
  editTheme: async function(currentTheme) {
    try {
      return await http.put('tema/', currentTheme);
    } catch (e) {
      return e.response.data;
    }
  },
  deleteTheme: async function(themeId) {
    try {
      return await http.delete(`tema/${themeId}`);
    } catch (e) {
      console.log(e);
      return e.response.data;
    }
  },
};
